import Link from 'next/link'

import { PlusIcon } from '../icons'
import { Container, ContainerInset } from '../layout/Container'

export const BottoFloatActionButton: React.FC<{
  onClick?: () => void
  href?: string
}> = (props) => {
  // NOTE: スクロールを阻害しないため pointer-events-none が必要
  return (
    <div
      className={'fixed right-0 flex w-full pointer-events-none'}
      style={{ bottom: 'var(--footer-height)' }}
    >
      <Container>
        <ContainerInset>
          <div className="flex justify-end">
            <button
              onClick={props.onClick}
              className="bg-function w-[60px] h-[60px] rounded-full ml-auto pointer-events-auto"
            >
              {props.href ? (
                <Link href="/dinners/new" className="w-full h-full inline-flex">
                  <PlusIcon className="block m-auto fill-white" />
                </Link>
              ) : (
                <PlusIcon className="block m-auto fill-white" />
              )}
            </button>
          </div>
        </ContainerInset>
      </Container>
    </div>
  )
}
